module.exports = __webpack_public_path__ + "media/application/images/logo_v3-f684c37ce34cd7a209dd9bdc8356db19.png";